import { LabelData } from './label/label.data';
import { LayerData } from './layer/layer.data';
import { TextLayerData } from './layer/text-layer.data';
import { TintableLayerData } from './layer/tintable-layer.data';

export class CommandData {
  
  static SET_COLOR: string = "CommandSetColor";
  static SET_POSITION: string = "CommandSetPosition";
  static SET_ROTATION: string = "CommandSetRotaiton";
  static SET_SCALE: string = "CommandSetScale";
  static SET_STYLE: string = "CommandSetStyle";
  static SET_TEXT: string = "CommandSetText";
  static SET_CROP: string = "CommandSetCrop";
  static SET_LINE_HEIGHT: string = "CommandSetLineHeight";
  static REMOVE_LAYER: string = "CommandRemoveLayer";
  static ADD_LAYER: string = "CommandAddLayer";
  static ORDER_LAYER: string = "CommandOrderLayer";

  private _target: LayerData;
  private _backup: LayerData;
  private _label: LabelData;
  private _action: string;
  private _data: any;

  /**
	 * Constructor
	 */
  constructor(label:LabelData, target: LayerData, action: string, data: any = null) {
    this._label = label;
    this._target = target;
    this._action = action;
    this._data = data;
    switch (this._action) {
      case CommandData.ADD_LAYER:
        this._backup = this._target;
        this._target = this._backup.clone();
        break;
    }
  }

  public get backup(): LayerData {
    return this._backup;
  }

  public get target(): LayerData {
    return this._target;
  }

  public set target(value: LayerData) {
    this._target = value;
  }

  public get label(): LabelData {
    return this._label;
  }

  public get action(): string {
    return this._action;
  }

  /**
	 * Apply 
	 */
  public apply(): void {
    switch (this._action) {
      case CommandData.SET_COLOR:
        (<TintableLayerData>this._target).color = this._data;
        this._target.invalidate();
        break;
      case CommandData.REMOVE_LAYER:
        this._label.removeLayer(this._target);
        break;
      case CommandData.ADD_LAYER:
        this._target.source = LayerData.CLIPBOARD;
        this._label.addLayer(this._target);
        break;
      case CommandData.ORDER_LAYER:
        var i: number;

        if (this._data < this._target.index) {
          for (i = 0; i < this._label.layers.length; i++) {
            if (this._label.layers[i].index >= this._data && this._label.layers[i].index < this._target.index) {
              this._label.layers[i].index++;
            }
          }
        } else if (this._target.index < this._data ) {
          for (i = 0; i < this._label.layers.length; i++) {
            if (this._label.layers[i].index > this._target.index && this._label.layers[i].index <= this._data ) {
              this._label.layers[i].index--;
            }
          }
        }

        this._target.index = this._data;
        this.label.reorderTab(true);
        break;
      case CommandData.SET_POSITION:
        this._target.rotation = this._data.rotation;
        this._target.x = this._data.x;
        this._target.y = this._data.y;
        this._target.width = this._data.width;
        this._target.height = this._data.height;
        this._target.invalidate();
        break;
      case CommandData.SET_LINE_HEIGHT:
        this._target.y = this._data.y;
        this._target.height = this._data.height;
        this._target.invalidate();
        break;
      case CommandData.SET_STYLE:
        this._target.x = this._data.x;
        this._target.y = this._data.y;
        this._target.rotation = this._data.rotation;
        (<TextLayerData>this._target).font = this._data.font;
        (<TextLayerData>this._target).size = this._data.size;
        (<TextLayerData>this._target).bold = this._data.bold;
        (<TextLayerData>this._target).italic = this._data.italic;
        (<TextLayerData>this._target).underline = this._data.underline;
        (<TextLayerData>this._target).align = this._data.align;
        (<TextLayerData>this._target).leading = this._data.leading;
        (<TextLayerData>this._target).text = this._data.text;
        this._target.invalidate();
        break;
      case CommandData.SET_CROP:
        //(<ImageLayerData>this._target).crop = this._data as Rectangle;
        this._target.invalidate();
        break;
    }
  }

  /**
   * Cleanup 
   */
  public cleanup(): void {
    this._label = null;
    this._backup = null;
    this._target = null;
    this._action = null;
    this._data = null;
  }	
}